import { useI18n } from 'vue-i18n';
import useDialogsStore from '@/stores/dialogs';

export const useNotification = () => {
  // Libs
  const { t, te } = useI18n();
  const { toggleGlobalDialog } = useDialogsStore();

  const invokeAlert = (type, msg, description) => {
    let convertedMessage = te(msg) ? t(msg) : msg;

    // Handle default messages when no msg is provided
    if (!msg) {
      if (type === 'error') {
        convertedMessage = t('generic.genericError');
      } else if (type === 'success') {
        convertedMessage = t('generic.success');
      }
    }

    toggleGlobalDialog({
      type,
      msg: convertedMessage,
      description
    });
  };

  const showSuccessAlert = (msg, description) =>
    invokeAlert('success', msg, description);
  const showErrorAlert = (msg, description) =>
    invokeAlert('error', msg, description);

  return {
    showSuccessAlert,
    showErrorAlert
  };
};
